import Collection from "./Collection";

/**
 * Provides a rendering and updating for items in {@link Collection}s
 * @class   Group
 * @extends Collection
 */
export default class Group extends Collection {
    constructor() {
        super();
    }

    /**
     * Updates all children recursively
     * @method Group#update
     * @param {Float} factor [description]
     */
    update(factor) {
        this.each((item)=> {
            item.update(factor);
        }, this);
    }
}


/** WEBPACK FOOTER **
 ** ./src/Group.js
 **/